module.exports = __webpack_public_path__ + "static/media/plus-insta.54573950.svg";